import React, { useState, useRef } from "react"
import { Container, DialogContent, styled } from "@mui/material"

import Intro from "./HomeComponents/Intro"
import WorkGrid from "./HomeComponents/WorkGrid"
import CustomDialog from "../WorkDetail/WorkDetailComponents/CustomDialog"
import WorkDetail from "../WorkDetail/WorkDetail"
import History from "./HomeComponents/History"
import HOne from "../../TextBlocks/HOneTextBlock"
import Foot from "../Footer/Foot"

const MainContainer = styled(Container)(({ theme }) => ({
  paddingLeft: theme.spacing(0) + "!important",
  paddingRight: theme.spacing(0) + "!important",
  backgroundColor: theme.palette.secondary.main,
}))

const HomePage: React.FC = () => {
  // IMPORTANT: this ref should ONLY be used for the dialog scroll container
  const dialogScrollRef = useRef<HTMLDivElement>(null)

  const [open, setOpen] = useState(false)
  const [selectedWork, setSelectedWork] = useState<any | null>(null)

  const handleOpen = (work: any) => {
    setSelectedWork(work)
    setOpen(true)

    // Google Analytics event tracking
    if (window.gtag) {
      window.gtag("event", "select_content", {
        content_type: "work",
        item_id: work.id,
        title: work.title,
      })
    }
  }

  const handleClose = () => {
    console.log("Dialog closing")
    setSelectedWork(null)
    setOpen(false)
  }

  return (
    <MainContainer maxWidth={false}>
      <Intro />
      <WorkGrid onWorkClick={handleOpen} />

      <CustomDialog open={open} onClose={handleClose} scroll="paper">
        <DialogContent
          ref={dialogScrollRef}
          sx={{
            // Helps prevent "scrolling the page behind" when you hit scroll boundaries
            overscrollBehavior: "contain",
            // Optional but often helps on mobile:
            WebkitOverflowScrolling: "touch",
            p: 0,
          }}
        >
          {selectedWork && (
            <WorkDetail
              id={selectedWork.id}
              onClose={handleClose}
              // NOTE: do NOT pass the dialog ref down into WorkDetail
            />
          )}
        </DialogContent>
      </CustomDialog>

      <History children={<HOne TitleOne={"Work"} TitleTwo={"History"} />} />
      <Foot />
    </MainContainer>
  )
}

export default HomePage
